export const Challenge_Single_EN = {
  // Single challenge
  challenge: {
    status: {
      ongoing: "Challenge ends in",
      ended: "Challenge ended",
      starting: "Challenge starting in",
    },
    counter: {
      days: "d",
      hours: "h",
      minutes: "m",
      seconds: "s",
    },
    starts: "Starts in",
    ends: "Ends in",
    leaderboard: {
      headline: "Leaderboard",
      tabs: {
        ALL: "All",
        FRIENDS: "Friends",
        FOLLOWING: "Following",
      },
      score: {
        yours: "Your score",
        others: "Other participants",
        description:
          "Your result will be shown here as soon as you have set a score",
        noParticipants: "Be the first to participate.",
        noFriends:
          "You don't have any friends actively participating in this challenge yet",
        noFollowing: "You are not following anyone on this account yet",
      },
    },
    description: {
      what: {
        headline: "What to do",
      },
      how: {
        headline: "How we calculate your score",
      },
    },
    buttons: {
      tabs: {
        back: "Back to all",
      },
      join: "Join",
      joinThisChallenge: "Join challenge",
      joined: "Joined",
      submit: "Submit score",
    },
    criteria: {
      headline: "How is the score calculated",
    },
    terms: {
      heading: "Terms",
      desc: "In order for you to claim your prize, you would have to update your profile with contact details such as email address. Otherwise we will not be able to reach out to you to present you with your well deserved prize. It will instead be awarded to the next player on the leaderboard.",
      preBrand: "You need to be present at the event and show up ",
      postBrand:
        "on the day you have won and within opening hours in order to claim your prize. If you are unable to show up, then we can unfortunately not grand you your otherwise well deserved prize. It will instead be awarded to the next player on the leaderboard.",
    },
    participants: {
      participating: "participating",
      and: "and",
      more: "more",
      participated: "participated",
    },
    disclaimers: {
      CSGO: "CS2 is a registered trademark of Valve. Trademarks are the property of their respective owners. Game materials copyright Valve. Valve has not endorsed and is not responsible for this site or its content.",
      Dota2:
        "Dota2 is a registered trademark of Valve. Trademarks are the property of their respective owners. Game materials copyright Valve. Valve has not endorsed and is not responsible for this site or its content.",
      PUBG: "PUBG is a registered trademark of PUBG Corporation. Trademarks are the property of their respective owners. Game materials copyright PUBG Corporation. PUBG Corporation has not endorsed and is not responsible for this site or its content.",
      f12022:
        "F1® 22 Game is official product of the FIA FORMULA ONE WORLD CHAMPIONSHIP. EA, EA SPORTS, the EA SPORTS logo, Codemasters, EGO and the Codemasters logo are trademarks of Electronic Arts Inc. Trademarks are the property of their respective owners. Electronic Arts Inc. has not endorsed and is not responsible for this site or its content.",
      f12023:
        "F1® 23 Game is official product of the FIA FORMULA ONE WORLD CHAMPIONSHIP. EA, EA SPORTS, the EA SPORTS logo, Codemasters, EGO and the Codemasters logo are trademarks of Electronic Arts Inc. Trademarks are the property of their respective owners. Electronic Arts Inc. has not endorsed and is not responsible for this site or its content.",
      f12024:
        "F1® 24 Game is official product of the FIA FORMULA ONE WORLD CHAMPIONSHIP. EA, EA SPORTS, the EA SPORTS logo, Codemasters, EGO and the Codemasters logo are trademarks of Electronic Arts Inc. Trademarks are the property of their respective owners. Electronic Arts Inc. has not endorsed and is not responsible for this site or its content.",
      "lego-f1":
        "LEGO® and the LEGO logo are trademarks of the LEGO Group. ©2024 The LEGO Group. The F1 logo, FORMULA 1, F1, GRAND PRIX and related marks are trademarks of Formula One Licensing BV, a Formula 1 company. All other trademarks, logos and copyrights, including those of the teams featured, are the property of their respective owners. F1® 24 Game is official product of the FIA FORMULA ONE WORLD CHAMPIONSHIP. EA, EA SPORTS, the EA SPORTS logo, Codemasters, EGO and the Codemasters logo are trademarks of Electronic Arts Inc. Trademarks are the property of their respective owners. Electronic Arts Inc. has not endorsed and is not responsible for this site or its content.",
      fallguys:
        "Fall Guys is a registered trademark of Mediatonic Limited. Trademarks are the property of their respective owners. Game materials copyright Mediatonic Limited. Mediatonic Limited has not endorsed and is not responsible for this site or its content.",
      fh5: "Forza Horizon is a registered trademark of Microsoft Studios. Trademarks are the property of their respective owners. Game materials copyright Microsoft Studios. Microsoft Studios has not endorsed and is not responsible for this site or its content.",
      fm8: "Forza Motorsport is a registered trademark of Microsoft Studios. Trademarks are the property of their respective owners. Game materials copyright Microsoft Studios. Microsoft Studios has not endorsed and is not responsible for this site or its content.",
      fortnite:
        "Fortnite is a registered trademark of Epic Games. Trademarks are the property of their respective owners. Game materials copyright Epic Games. Epic Games has not endorsed and is not responsible for this site or its content. As an Amazon Associate we earn from qualifying purchases.",
    },
    highlights: {
      heading: "Latest highlights",
      pubg: "Get some kills in PUBG to appear in our highlights",
      fortnite: "Get some kills in Fortnite to appear in our highlights",
      new: "New",
      description: "Join the challenge and play to appear in highlights",
    },
    creator: {
      headline: "Created by",
    },
  },
};
